import { FC } from 'react';

import { AutocompleteField } from '@app/components/common';
import { FieldComponentProps } from '@app/components/common/types';

export const RouteNumberField: FC<FieldComponentProps<EntityBase>> = ({ value, onChange, ...props }) => { 
  return <AutocompleteField 
    id='route_number_field'  
    value={value}
    onChange={onChange}
    {...props}
  />;
}; 